<template>
  <div class="page">
    <div class="page__bd">
     
     
      <div class="x-card" v-if="type == '开庭公告'">
        <h5 class="x-card-title">{{type}}</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">案号</span>
          <p>{{ initData.detailPage.caseNumber }}</p>
          <span class="x-card-content-title">案由</span>
          <p>{{ initData.detailPage.caseOrigin}}</p>
          <span class="x-card-content-title">当事人	</span>
          <p>{{ initData.detailPage.parties}}</p>
          <span class="x-card-content-title">法院	</span>
          <p>{{ initData.detailPage.court }}</p>
          <span class="x-card-content-title">法庭	</span>
          <p>{{ initData.detailPage.tribunal }}</p>
          <span class="x-card-content-title">承办部门	</span>
          <p>{{ initData.detailPage.holdingDepartment ? initData.detailPage.holdingDepartment :'-' }}</p>
          <span class="x-card-content-title">审判长/主审人	</span>
          <p>{{ initData.detailPage.presidingJudge ? initData.detailPage.presidingJudge :'-' }}</p>
          <span class="x-card-content-title">开庭日期	</span>
          <p>{{ initData.detailPage.lawfulDate ? initData.detailPage.lawfulDate :'-' }}</p>
          <span class="x-card-content-title">排期日期	</span>
          <p>{{ initData.detailPage.scheduleDate ? initData.detailPage.scheduleDate :'-' }}</p>
        </div>
      </div>
      
      <div class="x-card" v-if="type == '法院公告'">
        <h5 class="x-card-title">{{type}}</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">案号</span>
          <p>{{ initData.detailPage.caseNumber }}</p>
          <span class="x-card-content-title">案由</span>
          <p>{{ initData.detailPage.caseOrigin }}</p>
          <span class="x-card-content-title">当事人</span>
          <p>{{ initData.detailPage.parties}}</p>
          <span class="x-card-content-title">公告类型</span>
          <p>{{ initData.detailPage.announcementType }}</p>
          <span class="x-card-content-title">公告人</span>
          <p>{{ initData.detailPage.Announcer }}</p>
          <span class="x-card-content-title">刊登版面</span>
          <p>{{ initData.detailPage.publishLayout ? initData.detailPage.publishLayout : '-'}}</p>
          <span class="x-card-content-title">刊登日期</span>
          <p>{{ initData.detailPage.publishDate }}</p>
          <span class="x-card-content-title">内容</span>
          <p>{{ initData.detailPage.content }}</p>
        </div>
      </div>

      <div class="x-card" v-if="type == '终本案件'">
        <h5 class="x-card-title">{{type}}</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">案号</span>
          <p>{{ initData.detailPage.caseNumber }}</p>
          <span class="x-card-content-title">执行人</span>
          <p>{{ initData.detailPage.personEnforcement }}</p>
          <span class="x-card-content-title">疑似申请执行人</span>
          <p>{{ initData.detailPage.suspectedApplyEnforcement ? initData.detailPage.suspectedApplyEnforcement : '-'}}</p>
          <span class="x-card-content-title">证件号/组织机构代码</span>
          <p>{{ initData.detailPage.orgInsBarCode ? initData.detailPage.orgInsBarCode : '-'}}</p>
          <span class="x-card-content-title">未履行金额(元)</span>
          <p>{{ initData.detailPage.failureAmount }}</p>
          <span class="x-card-content-title">执行标的(元)</span>
          <p>{{ initData.detailPage.subjectMatterAmount ? initData.detailPage.subjectMatterAmount : '-'}}</p>
          <span class="x-card-content-title">立案日期</span>
          <p>{{ initData.detailPage.filingCaseDate ? initData.detailPage.filingCaseDate : '-' }}</p>
          <span class="x-card-content-title">终本日期</span>
          <p>{{ initData.detailPage.finalDate ? initData.detailPage.finalDate : '-'}}</p>
          <span class="x-card-content-title">执行法院</span>
          <p>{{ initData.detailPage.executiveCourt }}</p>
        </div>
      </div>

      <div class="x-card" v-if="type == '失信被执行人'">
        <h5 class="x-card-title">{{type}}</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">案号</span>
          <p>{{ initData.detailPage.caseNumber }}</p>
          <span class="x-card-content-title">执行依据文号</span>
          <p>{{ initData.detailPage.accordingNumber }}</p>
          <span class="x-card-content-title">失信被执行人</span>
          <p>{{ initData.detailPage.breachPersonExecution}}</p>
          <span class="x-card-content-title">证件号/组织机构代码</span>
          <p>{{ initData.detailPage.orgInsBarCode ? initData.detailPage.orgInsBarCode : '-'}}</p>
          <span class="x-card-content-title">疑似申请执行人</span>
          <p>{{ initData.detailPage.suspectedApplyEnforcement ? initData.detailPage.suspectedApplyEnforcement : '-'}}</p>
          <span class="x-card-content-title">涉案金额(元)</span>
          <p>{{ initData.detailPage.involvedCaseAmount ? initData.detailPage.involvedCaseAmount : '-'}}</p>
          <span class="x-card-content-title">执行法院</span>
          <p>{{ initData.detailPage.executiveCourt ? initData.detailPage.executiveCourt : '-'}}</p>
          <span class="x-card-content-title">做出执行依据单位</span>
          <p>{{ initData.detailPage.accordingOrg  ? initData.detailPage.accordingOrg : '-'}}</p>
          <span class="x-card-content-title">被执行人的履行情况</span>
          <p>{{ initData.detailPage.performanceStatus  ? initData.detailPage.performanceStatus : '-'}}</p>
          <span class="x-card-content-title">立案日期</span>
          <p>{{ initData.detailPage.filingCaseDate  ? initData.detailPage.filingCaseDate : '-'}}</p>
          <span class="x-card-content-title">发布日期</span>
          <p>{{ initData.detailPage.releaseDate  ? initData.detailPage.releaseDate : '-'}}</p>
          <span class="x-card-content-title">失信被执行人行为具体情形</span>
          <p>{{ initData.detailPage.behaviorStatus  ? initData.detailPage.behaviorStatus : '-'}}</p>
          <span class="x-card-content-title">生效法律文书确定的义务</span>
          <p>{{ initData.detailPage.obligation  ? initData.detailPage.obligation : '-'}}</p>
        </div>
      </div>

      <div class="x-card" v-if="type == '被执行人'">
        <h5 class="x-card-title">{{type}}</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">案号</span>
          <p>{{ initData.detailPage.caseNumber }}</p>
          <span class="x-card-content-title">被执行人</span>
          <p>{{ initData.detailPage.personEnforcement }}</p>
          <span class="x-card-content-title">组织机构代码</span>
          <p>{{ initData.detailPage.orgInsBarCode}}</p>
          <span class="x-card-content-title">疑似申请执行人</span>
          <p>{{ initData.detailPage.suspectedApplyEnforcement ? initData.detailPage.suspectedApplyEnforcement : '-'}}</p>
          <span class="x-card-content-title">执行标的(元)</span>
          <p>{{ initData.detailPage.subjectMatterAmount }}</p>
          <span class="x-card-content-title">执行法院</span>
          <p>{{ initData.detailPage.executiveCourt ? initData.detailPage.executiveCourt : '-'}}</p>
          <span class="x-card-content-title">立案日期</span>
          <p>{{ initData.detailPage.filingCaseDate }}</p>
        </div>
      </div>

      <div class="x-card" v-if="type == '股权冻结'">
        <h5 class="x-card-title">基础信息</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">执行通知书文号</span>
          <p>{{ initData.detailPage.basicsExecutionNoticeNumber }}</p>
          <span class="x-card-content-title">冻结状态</span>
          <p>{{ initData.detailPage.basicsFreezeStatus }}</p>
          <span class="x-card-content-title">被执行人</span>
          <p>{{ initData.detailPage.basicsPersonEnforcement}}</p>
          <span class="x-card-content-title">疑似申请执行人</span>
          <p>{{ initData.detailPage.basicsSuspectedApplyEnforcement ? initData.detailPage.basicsSuspectedApplyEnforcement : '-'}}</p>
          <span class="x-card-content-title">股权所在企业</span>
          <p>{{ initData.detailPage.basicsStockEnterprise }}</p>
          <span class="x-card-content-title">股权数额</span>
          <p>{{ initData.detailPage.basicsStockAmount ? initData.detailPage.basicsStockAmount : '-'}}</p>
          <span class="x-card-content-title">执行法院</span>
          <p>{{ initData.detailPage.basicsExecutiveCourt }}</p>
        </div>
        <h5 class="x-card-title">股权冻结信息</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">执行裁定文书号</span>
          <p>{{ initData.detailPage.freezeExecutionOrderNumber }}</p>
          <span class="x-card-content-title">公示日期</span>
          <p>{{ initData.detailPage.freezeAnnouncementDate }}</p>
          <span class="x-card-content-title">被执行人</span>
          <p>{{ initData.detailPage.freezePersonEnforcement}}</p>
          <span class="x-card-content-title">股权数额</span>
          <p>{{ initData.detailPage.freezeStockAmount }}</p>
          <span class="x-card-content-title">被执行人证件种类</span>
          <p>{{ initData.detailPage.freezePersonEnforcementIDType }}</p>
          <span class="x-card-content-title">被执行人证件号码</span>
          <p>{{ initData.detailPage.freezePersonEnforcementIDNumber ? initData.detailPage.freezePersonEnforcementIDNumber : '-'}}</p>
          <span class="x-card-content-title">冻结期限自</span>
          <p>{{ initData.detailPage.freezeStartDeadline }}</p>
          <span class="x-card-content-title">冻结期限至</span>
          <p>{{ initData.detailPage.freezeEndDeadline }}</p>
          <span class="x-card-content-title">冻结期限</span>
          <p>{{ initData.detailPage.freezeDeadline }}</p>
          <span class="x-card-content-title">执行事项</span>
          <p>{{ initData.detailPage.freezeExecutionMatters }}</p>
        </div>
      </div>

      <div class="x-card" v-if="type == '限制消费令'">
        <h5 class="x-card-title">{{type}}</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">案号</span>
          <p>{{ initData.listPage.caseNumber }}</p>
          <span class="x-card-content-title">限消令对象</span>
          <p>{{ initData.listPage.croTargets }}</p>
          <span class="x-card-content-title">立案日期</span>
          <p>{{ initData.listPage.filingCaseDate}}</p>
          <span class="x-card-content-title">限制法定代表人</span>
          <p>{{ initData.listPage.legalRepresentative }}</p>
          <span class="x-card-content-title">申请人</span>
          <p>{{ initData.listPage.applicant }}</p>
          <span class="x-card-content-title">涉案金额(元)	</span>
          <p>{{ initData.listPage.involvedCaseAmount ? initData.listPage.involvedCaseAmount : '-'}}</p>
          <span class="x-card-content-title">内容正文</span>
          <p v-html="initData.listPage.croDetail"></p>
          <a target="_blank" rel="noopener noreferrer" :href="initData.listPage.originalText">查看原文</a>
        </div>
      </div>

      <div class="x-card" v-if="type == '送达公告'">
        <h5 class="x-card-title">{{type}}</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">公告名称</span>
          <p>{{ initData.listPage.announcementName }}</p>
          <span class="x-card-content-title">案号</span>
          <p>{{ initData.listPage.caseNumber }}</p>
          <span class="x-card-content-title">案由</span>
          <p>{{ initData.listPage.caseOrigin}}</p>
          <span class="x-card-content-title">案件身份</span>
          <p>{{ initData.listPage.caseIdentity }}</p>
          <span class="x-card-content-title">法院</span>
          <p>{{ initData.listPage.court }}</p>
          <span class="x-card-content-title">发布日期	</span>
          <p>{{ initData.listPage.releaseDate ? initData.listPage.releaseDate : '-'}}</p>
          <span class="x-card-content-title">公告内容</span>
          <p>{{ initData.detailPage.saDetail }}</p>
        </div>
      </div>

      <div class="x-card" v-if="type == '立案信息'">
        <h5 class="x-card-title">{{type}}</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">案号</span>
          <p>{{ initData.listPage.caseNumber }}</p>
          <span class="x-card-content-title">案由</span>
          <p>{{ initData.listPage.caseOrigin }}</p>
          <span class="x-card-content-title">案件类型</span>
          <p>{{ initData.listPage.caseType ? initData.listPage.caseType : '-'}}</p>
          <span class="x-card-content-title">当事人</span>
          <p>{{ initData.listPage.parties }}</p>
          <span class="x-card-content-title">法院</span>
          <p>{{ initData.listPage.court }}</p>
          <span class="x-card-content-title">承办部门</span>
          <p>{{ initData.listPage.holdingDepartment ? initData.listPage.holdingDepartment : '-'}}</p>
          <span class="x-card-content-title">承办法官</span>
          <p>{{ initData.listPage.holdingJudge ? initData.listPage.holdingJudge : '-'}}</p>
          <span class="x-card-content-title">法官助理</span>
          <p>{{ initData.listPage.judgeAssistant ? initData.listPage.judgeAssistant : '-'}}</p>
          <span class="x-card-content-title">案件状态</span>
          <p>{{ initData.listPage.caseStatus ? initData.listPage.caseStatus : '-'}}</p>
          <span class="x-card-content-title">立案时间</span>
          <p>{{ initData.listPage.filingCaseDate ? initData.listPage.filingCaseDate : '-'}}</p>
          <span class="x-card-content-title">开庭日期</span>
          <p>{{ initData.listPage.lawfulDate ? initData.listPage.lawfulDate : '-'}}</p>
          <span class="x-card-content-title">结束日期</span>
          <p>{{ initData.listPage.endDate ? initData.listPage.endDate : '-'}}</p>
        </div>
      </div>

      <div class="x-card" v-if="type == '破产案件'">
        <h5 class="x-card-title">{{type}}</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">案号</span>
          <p>{{ initData.detailPage.caseNumber }}</p>
          <span class="x-card-content-title">案件类型</span>
          <p>{{ initData.detailPage.caseType }}</p>
          <span class="x-card-content-title">被申请人</span>
          <p>{{ initData.detailPage.defendingApplicant}}</p>
          <span class="x-card-content-title">申请人</span>
          <p>{{ initData.detailPage.applicant }}</p>
          <span class="x-card-content-title">经办法院</span>
          <p>{{ initData.detailPage.court }}</p>
          <span class="x-card-content-title">管理人机构</span>
          <p>{{ initData.detailPage.managerOrg ? initData.detailPage.managerOrg : '-'}}</p>
          <span class="x-card-content-title">管理人主要负责人</span>
          <p>{{ initData.detailPage.mainDutyer ? initData.detailPage.mainDutyer : '-'}}</p>
          <span class="x-card-content-title">公开日期</span>
          <p>{{ initData.detailPage.pubDate }}</p>
        </div>
      </div>

      <div class="x-card" v-if="type == '司法拍卖'">
        <h5 class="x-card-title">{{type}}</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">公告名称</span>
          <p>{{ initData.listPage.subjectAuction }}</p>
          <span class="x-card-content-title">拍卖标的物</span>
          <p>{{ initData.listPage.subjectAuction }}</p>
          <span class="x-card-content-title">起拍价（元）</span>
          <p>{{ initData.listPage.startingPrice}}</p>
          <span class="x-card-content-title">评估价（元）</span>
          <p>{{ initData.listPage.valuation }}</p>
          <span class="x-card-content-title">拍卖时间</span>
          <p>{{ initData.listPage.auctionDate }}</p>
          <span class="x-card-content-title">委托法院	</span>
          <p>{{ initData.listPage.appointCourt ? initData.listPage.appointCourt : '-'}}</p>
          <span class="x-card-content-title">内容正文</span>
          <p v-html="initData.listPage.auctionDetails"></p>
        </div>
      </div>

      <div class="x-card" v-if="type == '询价评估'">
        <h5 class="x-card-title">{{type}}</h5>
        <div class="x-card-content">
          <span class="x-card-content-title">案号</span>
          <p>{{ initData.listPage.caseNumber }}</p>
          <span class="x-card-content-title">标的物</span>
          <p>{{ initData.listPage.subjectMatter }}</p>
          <span class="x-card-content-title">标的物所有人</span>
          <p>{{ initData.listPage.ownerSubjectMatter}}</p>
          <span class="x-card-content-title">案件当事人</span>
          <p>{{ initData.listPage.casePrivity }}</p>
          <span class="x-card-content-title">确定参考价方式</span>
          <p>{{ initData.listPage.rePriceMethod }}</p>
          <span class="x-card-content-title">询价结果（元）</span>
          <p>{{ initData.listPage.inquiryResult ? initData.listPage.inquiryResult : '-'}}</p>
          <span class="x-card-content-title">法院</span>
          <p>{{ initData.listPage.court }}</p>
          <span class="x-card-content-title">发布日期</span>
          <p>{{ initData.listPage.releaseDate }}</p>
          <a target="_blank" rel="noopener noreferrer" :href="initData.listPage.originalText">查看原文</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object,
    type: String
  },
  data() {
    return {
      form:{
      }
    };
  },
  created() {
    let me= this
    if(me.type == '政府约谈' ||  me.type == '产品召回'){
      me.loadData(me.initData.listPage.uuid);
    }
   
  },
  methods: {
    loadData(id) {
      let me = this
      if (!id) {
        return;
      }
      me.$loading({
        url: "/api/document/eOperatingRisk/getNews?uuid=" + id,
      }).then(function (res) {
        if (res.data) {
          me.form = res.data;
         
        }
      });
    },
  },
};
</script>

<style scoped>
.page {
  background: #fff;
  height: 100%;
}
.x-card-title {
  background: #f0f7fc;
  font-size: 16px;
  padding: 10px 10px;
  font-weight: 400;
  color: #0C88F1;

}
.x-card-content{
  padding: 4px 10px;
  font-size: 14px;
  color: #333;
}
.x-card-content-title{
  display: block;
  font-weight: bold;
  margin-top:10px !important;
}
.news-date{
  display: block;
  font-size: 12px;
  color: #8890a5;
 text-align: center;
}
.news-title{
  margin: 10px 0px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
}
.news-content{
  margin: 10px 0px;
  font-size: 14px;
  color: #333;
  text-indent: 20px;
}
</style>